module.exports = __webpack_public_path__ + "static/media/nigeria.42b53d7f.svg";